import axios from "axios";
import { FileUploadStart } from './types';

export const fileUploadStart = async (props: FileUploadStart) => {
  try {
    const response = await axios.post(
    `${process.env.REACT_APP_PROXY_URL}/v1/upload/start`,
    {
      action: "start",
      object_name: props.fileName,
      file_size: props.fileSize,
      compound_number: props.compoundNumber,
      protocol_number: props.protocolNumber ?? "000",
      transfer_id: props.transferId,
      environment: props.environment,
      file_count: 1,
      is_data_format: props.isDataFormat,
      is_offline_flow: props.isOfflineFlow,
      supplier_org: props.supplierOrg,
      dts_version: props.dtsVersion,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
      },
    });

    const urls = response?.data?.urls.map((urlInfo: any) => urlInfo[1]);
    return { uploadUrls: urls, uploadId: response?.data?.upload_id, key: response?.data?.key }; // Return the URLs
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to start file upload.";
    return { error: true, message };
  }
};
